<template>
    <PageBaseLayout>
        <template #main>
            <div>
                <div class="_backlight"></div>
                <div class="header-bar">
                    <video v-if="videoReady" :src="loadedVideoUrl" autoplay muted loop playsinline disablepictureinpicture></video>
                </div>
                <div class="container text-left">
                    <br>
                    <p>Alpha G.O.A.T.s will be minted <span class="title large">One by One</span></p>
                    <p>Starting from the <span class="title large">Least Rare</span></p>
                    <p>All the way to the <span class="title large">Most Legendary</span></p>

                    <!-- old style -->
                    <!-- <div style="display: inline-block;">
                        <br>
                        <p class="text-left">Alpha G.O.A.T.s will be minted</p>
                        <p class="text-right title large ">one by one</p>
                        <br>
                        <p class="text-left">Starting from the <span class="title large">Least Rare</span></p>
                        <p class="text-right">All the way to the <span class="title large">most legendary</span></p>
                    </div> -->
                </div>
            </div>
        </template>

        <template #bottom>
            <div class="bottom">
                <BaseButton pageId="GemMechanism04">Walk Me Through It &nbsp;<i class="icon middle next"></i></BaseButton>
            </div>
        </template>
    </PageBaseLayout>

</template>

<script>
import { loadCachedUrl } from '@/videoManager';

export default {
    async mounted() {
        this._isActive = true;

        const url = await loadCachedUrl(require('@/assets/vids/gem-header.mp4'));

        if (!this._isActive) {
            return;
        }

        this.loadedVideoUrl = url;
        this.videoReady = true;
    },
    unmounted() {
        this._isActive = false;
    },
    data() {
        return {
            videoReady: false,
            loadedVideoUrl: ""
        };
    }
}
</script>

<style lang="scss" scoped>

// ._backlight {
//     position: fixed;
//     inset: 0;
//     background-image: url("data:image/svg+xml;base64,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");
//     background-position: top right;
//     background-repeat: no-repeat;
//     pointer-events: none;
// }

.header-bar {
    display: block;
    min-height: 326px;
    
    video {
        margin-top: -20px;
        min-height: 326px;
        margin-bottom: 20px;
    }
}

</style>